import classnames from 'classnames'
import { getConfig } from 'config/envVars'
import Button from 'components/Button'
import { Card } from '../../../api/src/card/interfaces/card.interface'
import * as styles from './cardBack.module.css'
import Clickable from 'components/Clickable'
import { useRouter } from 'next/router'
import { useEffect, useState } from 'react'
import { CardOrder } from '../../../api/src/order/cardOrder.entity'
import { addCardToCart, useCart } from 'modules/Orders/remote'
import { isSuccessful } from 'utilities/api'

const config = getConfig()

interface CardBackProps {
  card: Partial<Card>,
  isFlipped: Boolean,
  size?: 'small' | 'large',
  setIsFlipped: Function,
}

const CardBack = ({ card, isFlipped, size = 'large', setIsFlipped }: CardBackProps) => {
  const router = useRouter()
  const { occasionId } = router.query
  const [isAddingCard, setIsAddingCard] = useState(false)
  console.log({ card, width: card.widthInches, height: card.heightInches, hasSize: !!(card.widthInches && card.heightInches) })
  const handleItemChosen = async (cardId: number) => {
    if (!occasionId) { return }
    setIsAddingCard(true)
    const payload = { cardId, occasionId: Number(occasionId), source: 'card back' }
    const addCardToCartResponse = await addCardToCart(payload)
    if (isSuccessful(addCardToCartResponse)) {
      router.push('/my/bundle')
    }
  }
  const { cart } = useCart()
  const cartCardOrders = cart?.cardOrders
  // push user to sign up then checkout once the card is in their cart
  useEffect(() => {
    if (isAddingCard && cartCardOrders && cartCardOrders.find((cartCardOrder: CardOrder) => cartCardOrder?.cardId === card.id)) {
      // router.push(`/signup?redirectTo=${encodeURIComponent('/checkout')}`)
      router.push('/checkout')
    }
  }, [isAddingCard, cartCardOrders])

  return <div className={classnames(styles.cardDetails, { [styles.cardDetailsFlipped]: isFlipped })}>
    { size === 'large' && <div className={styles.detailsAdditions}>
        <Clickable onClick={() => setIsFlipped(false)}>
          <div className={styles.imageContainer}>
            <img src={`${config.imageHostname}${card.images?.[0]?.filename}`} alt={card.textFront} className={styles.image} />
          </div>
        </Clickable>
        { occasionId && <Button onClick={() => { handleItemChosen(card.id as number) }} isSecondary variant='small' className={styles.buyButton}>Buy card now</Button> }
      </div>
    }
    <div className={styles.cardDetailsRow}>
      <span className={styles.cardDetailsRowLabel}>Front text</span>
      {card.textFront}
    </div>
    <div className={styles.cardDetailsRow}>
      <span className={styles.cardDetailsRowLabel}>Inside text</span>
      { card.textInside === '__blank' ? '[blank]' : card.textInside }
    </div>
    <div className={styles.cardDetailsRow}>
      <span className={styles.cardDetailsRowLabel}>Card size</span>
      { !!(card.widthInches && card.heightInches)
        ? <>{card.widthInches}" x {card.heightInches}"</>
        : <>Not available</>
      }
    </div>
  </div>
}

export default CardBack
